/**
 * Applies tenant `settings.branding` to CSS variables consumed by Tailwind (`brand-500`, `brand-600`).
 */

const DEFAULT_TITLE = "Identity Armour";

/** Darken a `#RRGGBB` color toward black. */
export function darkenHex6(hex: string, factor: number): string {
  const h = hex.trim();
  if (!/^#[0-9A-Fa-f]{6}$/.test(h)) return h;
  const r = parseInt(h.slice(1, 3), 16);
  const g = parseInt(h.slice(3, 5), 16);
  const b = parseInt(h.slice(5, 7), 16);
  const f = Math.min(1, Math.max(0, factor));
  const toHex = (n: number) => n.toString(16).padStart(2, "0");
  return `#${toHex(Math.round(r * (1 - f)))}${toHex(Math.round(g * (1 - f)))}${toHex(
    Math.round(b * (1 - f))
  )}`;
}

/**
 * Sets `--brand-500` / `--brand-600` and optional `document.title` from `tenant.settings.branding`.
 */
export function applyTenantBrandingToDom(
  root: HTMLElement,
  settings: Record<string, unknown> | undefined
): void {
  const branding = settings?.branding;
  if (!branding || typeof branding !== "object" || Array.isArray(branding)) {
    root.style.removeProperty("--brand-500");
    root.style.removeProperty("--brand-600");
    if (document.title.includes("—")) {
      document.title = DEFAULT_TITLE;
    }
    return;
  }
  const b = branding as Record<string, unknown>;
  const primary = b.primaryColor;
  if (typeof primary === "string" && /^#[0-9A-Fa-f]{6}$/.test(primary.trim())) {
    const hex = primary.trim();
    root.style.setProperty("--brand-500", hex);
    root.style.setProperty("--brand-600", darkenHex6(hex, 0.12));
  } else {
    root.style.removeProperty("--brand-500");
    root.style.removeProperty("--brand-600");
  }
  const appName = b.appName;
  if (typeof appName === "string" && appName.trim()) {
    document.title = `${appName.trim()} — Identity Armour`;
  } else if (document.title.includes("—")) {
    document.title = DEFAULT_TITLE;
  }
}
